"use client";

import dynamic from "next/dynamic";

const BackToTopButton = dynamic(() => import("./BackToTopButton"), { ssr: false });

const Theme19ClientChrome = () => {
    return <BackToTopButton />;
};

export default Theme19ClientChrome;
